import { css } from '@emotion/react';

export const useStyles = (props) => ({
    floatingDiv: css({
        backgroundColor: "white",
        borderRadius: "8px",
        boxShadow: "0 0 5px 1px #d0d0d0",
        overflow: "hidden"
    }),
    floatingDivBarBottom: css({
        height: "50px",
    }),
    floatingDivContentButton: css({
        height: "50px",
        width: "100%",
        justifyContent: "left",
        color: "#00a7dd",
        textTransform: "capitalize",
        paddingLeft: "30px",
        marginTop: "2px",
        borderRadius: "0",
        "&:hover": {
            color: "#f6891f",
        }
    }),
    floatingDivContentButtonSelected: css({
        backgroundColor: "#00a7dd",
        color: "white",
        "&:hover": {
            backgroundColor: "#8fcff6",
            color: "white",
        }
    }),
    datePickerDiv: css({
        height: "405px",
    }),
});
